const getDaysInMonth = (yearMonth: string): string[] => {
    const [year, month] = yearMonth.split("-").map(Number);
    const daysInMonth = new Date(year, month, 0).getDate();
    const days: string[] = [];

    for (let day = 2; day <= daysInMonth + 1; day++) {
        const date = new Date(year, month - 1, day);
        days.push(date.toISOString().split("T")[0]);
    }

    return days;
};

export { getDaysInMonth };
